import React from 'react';

import { truncateHoursString } from '../../activities/utils';
import DollarOutput from '../../utils/DollarOutput';
import { BookingOption } from '../../../types/Activity';

type Props<T> = {
  item: T;
  uiElements: Record<string, React.ComponentType<T>>;
};

const EditOrderBookingOptionRow = <T extends BookingOption>(
  props: Props<T>
) => {
  const {
    action: ActionElement,
    attendees: AttendeesElement,
  } = props.uiElements;

  return (
    <tr className={'listRow'}>
      <td>
        <ActionElement {...props.item} />
      </td>
      {AttendeesElement && (
        <td>
          <AttendeesElement {...props.item} />
        </td>
      )}
      <td
        dangerouslySetInnerHTML={{
          __html: `<div><strong>${props.item.title}</strong></div><div>${props.item.description}</div>`,
        }}
      />
      <td>{props.item.duration}</td>
      <td title={props.item.hours}>{truncateHoursString(props.item.hours)}</td>
      <td>{props.item.interval}</td>
      <td>
        <DollarOutput value={props.item.price} />
      </td>
      <td>{props.item.pricingModel}</td>
    </tr>
  );
};

export default EditOrderBookingOptionRow;
